import { server_ip } from "../config";

export async function uploadPhoto(token,formData,folder,name=null){
    try {
        let response= await fetch(`${server_ip}/api/documents-s3/cms/upload`, {
          method: 'POST',
          body: formData,
          headers: {
            Authorization: `Bearer ${token}`,
            folder,
            name,
            //'content-type': 'multipart/form-data',
          },
        });
        let json = await response.json();
        // if(json.errno){
        //     alert(json.message)
        // }
        return json
    }  catch (error) {
        return {errno:1,message:'Unexpected error'}
    }
}
export async function uploadCV(formData,folder,name=null){
    try {
        let response= await fetch(`${server_ip}/api/documents-s3/cv/upload`, {
          method: 'POST',
          body: formData,
          headers: {
            folder,
            name,
            //'content-type': 'multipart/form-data',
          },
        });
        let json = await response.json();
        // if(json.errno){
        //     alert(json.message)
        // }
        return json
    }  catch (error) {
        return {errno:1,message:'Unexpected error'}
    }
}